<template>
  <div class="dynamic">
    <div class="colorCon"></div>
    <div class="backBtn" @click="gotoPage()">
        <img src="../assets/back.png" alt="">
        <span>星元动态</span>
    </div>
    <div class="textCon">
        <div class="publisher_name">{{detail.company_name}}</div>
        <div class="publish_time">{{detail.publish_time}}</div>
        <el-row v-if="detail.image_url && detail.image_url.length > 0" class="image_url" :gutter="53">
            <el-col :span="6" v-for="(item,index) in detail.image_url" :key="index">
                <div><img :src="item" alt=""></div>
            </el-col>
        </el-row>
        <div class="videoCon" v-if="detail.video_url">
            <video :src="detail.video_url" controls :poster="detail.video_cover_url"></video>
        </div>
        <div class="title">{{detail.title}}</div>
        <div class="content">{{detail.content}}</div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  data() {
    return{
      detail: {}
    }
  },
  mounted() {
    this.getDetail(this.$route.query.id);
  },
  methods: {
    gotoPage() {
      this.$router.go(-1);
    },
    getDetail(id) {
      $.ajax({
        type: "get",
        url: "/officialapi/custom/detail",
        async: true,
        data: {
          "id": id
        },
        success: (data) => {
          if (data["code"] == 0) {
            this.detail = data.data;
            document.title = "星元计划-" + this.detail.title;
          } else {
            this.$message.error(data.msg);
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dynamic{
    position: relative;
    padding: 94px 0px 95px 0px;
    background: #F9FAFB;
    .colorCon{
        position: absolute;
        height: 180px;
        width: 100%;
        background: linear-gradient(180deg, #DAE6FF 0%, rgba(228, 237, 255, 0) 99%);
        top: 0;
        left: 0;
        z-index: 0;
    }
    .backBtn{
        position: absolute;
        cursor: pointer;
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: 500;
        line-height: 34px;
        display: flex;
        align-items: center;
        letter-spacing: normal;
        color: #666666;
        top: 20px;
        left: 32px;
        z-index: 999;
        img{
            width: 24px;
            height: 24px;
            margin-right: 5px;
        }
    }
    .textCon{
        position: relative;
        z-index: 999;
        width: 1200px;
        margin: 0 auto;
        .publisher_name{
            font-family: Source Han Sans;
            font-size: 30px;
            font-weight: bold;
            line-height: 34px;
            display: flex;
            align-items: center;
            letter-spacing: normal;
            color: #222222;
            margin-bottom: 12px;
        }
        .publish_time{
            font-family: Source Han Sans;
            font-size: 16px;
            font-weight: normal;
            line-height: 34px;
            display: flex;
            align-items: center;
            letter-spacing: normal;
            color: #666666;
            margin-bottom: 29px;
        }
        .image_url{
            img{
                width: 100%;
                border-radius: 10px;
                aspect-ratio: 1;
                margin-bottom: 41px;
            }
        }
        .title{
            font-family: Source Han Sans;
            font-size: 30px;
            font-weight: bold;
            line-height: 34px;
            display: flex;
            align-items: center;
            letter-spacing: normal;
            color: #222222;
            margin-bottom: 30px;
        }
        .content{
            font-family: Source Han Sans;
            font-size: 20px;
            font-weight: normal;
            line-height: 34px;
            display: flex;
            align-items: center;
            letter-spacing: normal;
            color: #222222;
        }
    }
    .videoCon{   
        border-radius: 10px;
        width: 100%;
        height: 560px;
        margin-bottom: 44px;
        video{
            width: 100%;
            height: 100%;
        }
    }
}
</style>